import createSubscriptionRpcService from 'services/rpc/subscriptionRpcService';
import useAxios from '../utils/useAxios';

export default function useSubscriptionRpc() {
  return createSubscriptionRpcService(useAxios());
}
